import { CircularProgress, Grid } from '@material-ui/core';
import React from 'react';

interface Props {
    loading?: boolean;
    children?: React.ReactNode;
}

function PageContent(props: Props) {
    return (
        <React.Fragment>
            {props.loading ?
                <Grid style={{ padding: 20 }} container justifyContent="center" alignItems="center">
                    <CircularProgress color="secondary" />
                </Grid> : props.children
            }
        </React.Fragment>
    );
}

export default PageContent;